export default __webpack_public_path__ + "static/media/ProximaNova-Bold.09394b2a.otf";